import { Component, Ref } from 'vue-property-decorator'
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader.vue'
import VtGrid from '@/components/VtGrid/VtGrid.vue'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { AgGridOptions, AgGridRowModelType } from '@/shared/models/ag-grid.model'
import {
    GetContextMenuItemsParams,
    GridReadyEvent,
    MenuItemDef,
    SelectionChangedEvent
} from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import InteroperabilityModal from '@/modules/configurationModule/detail/vitrolink/interoperability/components/interoperability-modal/interoperability-modal.vue'
import { BaseCrud } from '@/shared/models/cruds.models'
import BaseCrudServerSideComponent from '@/shared/resources/base-crud-server-side.component'

@Component({
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        InteroperabilityModal
    }
})
export default class InteroperabilityGrid extends BaseCrudServerSideComponent<any> implements BaseCrud {
    @Ref() readonly interoperabilityModal!: any

    private actionTitle !: string
    private selectedRows !: Array<object>
    private rowData!: Array<object>
    private columnDefs!: Array<object>
    private gridApi !: any

    constructor() {
        super()
        this.actionTitle = ''
        this.selectedRows = []
        this.columnDefs = [
            { type: 'customCheckbox' },
            {
                type: 'text',
                headerName: i18n.tc('configuration.grid.device', 1),
                colId: 'device',
                field: 'device',
                minWidth: 250,
                flex: 1,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.ip'),
                colId: 'ip',
                field: 'ip',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            },
            {
                type: 'text',
                headerName: i18n.t('configuration.grid.port'),
                colId: 'port',
                field: 'port',
                minWidth: 150,
                flex: 1,
                filter: true,
                sortable: false
            }
        ]
        this.rowData = [
            {
                device: 'Dispositivo 1',
                ip: '198.168.1.20',
                port: '8080'
            },
            {
                device: 'Dispositivo 2',
                ip: '198.168.1.21',
                port: '8081'
            },
            {
                device: 'Dispositivo 3',
                ip: '198.168.1.22',
                port: '8082'
            }
        ]
        this.gridApi = null
    }

    get gridOptions(): AgGridOptions {
        return {
            sideBar: gridSideBarConfig,
            rowModelType: AgGridRowModelType.CLIENT_SIDE,
            getContextMenuItems: this.getContextMenuItems,
            onGridReady: this.onGridReady,
            onSelectionChanged: this.onSelectionChanged,
            getRowHeight: () => this.rowHeight
        }
    }

    getContextMenuItems(params: GetContextMenuItemsParams): MenuItemDef[] {
        if (!params?.node) {
            return []
        } else {
            return [
                {
                    name: this.$t('configuration.actions.update').toString()
                },
                {
                    name: this.$t('configuration.actions.delete').toString()
                },
                {
                    name: this.$t('configuration.actions.activate').toString()
                },
                {
                    name: this.$t('configuration.actions.deactivate').toString()
                }
            ]
        }
    }

    onSelectionChanged({ api }: SelectionChangedEvent) {
        this.selectedRows = api.getSelectedRows()
    }

    onGridReady(event: GridReadyEvent): void {
        this.state.gridApi = event.api
        this.state.columnApi = event.columnApi
    }

    showInteroperabilityModal(title: string) {
        this.actionTitle = title
        this.interoperabilityModal.show()
    }

    // TODO: Mejorar esto en Front
    async deleteInteroperability() {
        await this.$_showConfirmationModal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete').toString())
    }
}
